import {
  UserRepository,
  Either,
  UserFailure,
  right,
  left,
  User,
} from "../../domain";
import { UserRemoteDataSource, UserLocalDataSource } from "../data-sources";
import { UserRemoteDataSourceError } from "../core";

export class UserRepositoryImpl implements UserRepository {
  constructor(
    private readonly remoteDataSource: UserRemoteDataSource,
    private readonly localDataSource: UserLocalDataSource
  ) {}

  private handleError(error: Error): UserFailure {
    const message = error.message as UserRemoteDataSourceError;
    if (message === "NetworkError") return UserFailure.networkFailure();
    if (message === "WrongPasswordError")
      return UserFailure.wrongPasswordFailure();
    return UserFailure.serverFailure();
  }

  isLoggedIn(): boolean {
    return this.localDataSource.hasToken();
  }

  public async loginWithPassword(
    phone: string,
    password: string
  ): Promise<Either<UserFailure, null>> {
    try {
      const token = await this.remoteDataSource.loginWithPassword(
        phone,
        password
      );

      this.localDataSource.setToken(token);

      return right(null);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async getInfo(): Promise<Either<UserFailure, User>> {
    try {
      const res = await this.remoteDataSource.getUserInfo();
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public logOut(): void {
    this.localDataSource.deleteToken();
  }
}
